import { actionClient } from '@/api'

export default {

  namespaced: true,

  state: {
    token: localStorage.getItem('token') || null,
    currentUser: JSON.parse(localStorage.getItem('user') || 'null') || null,
    roles: [],
    activityList: []
  },


  mutations: {

    setToken(state, { token }) {
      state.token = token
      if (token === null) {
        localStorage.removeItem('token')
      } else {
        localStorage.setItem('token', token)
      }
    },

    setCurrentUser(state, { user, roles = [] }) {
      state.currentUser = user
      state.roles = roles
      if (user === null) {
        localStorage.removeItem('user')
      } else {
        localStorage.setItem('user', JSON.stringify(user))
      }
    },

    setActiveList(state, list) {
      state.activityList = list
    }

  },

  actions: {

    async login({ commit }, data) {
      const { token } = await actionClient.post('auth', data)
      commit('setToken', { token })
      const user = await actionClient.get('member/personal/me')
      commit('setCurrentUser', { user })
    },
    async mobileLogin({ commit }, data) {
      const { token } = await actionClient.post('mobile-auth', data)
      commit('setToken', { token })
      const user = await actionClient.get('member/personal/me')
      commit('setCurrentUser', { user })
    },

    async ddlogin({ commit }, data) {
      const { token } = await actionClient.post('dingtalk-auth', data)
      commit('setToken', { token })
      const user = await actionClient.get('member/personal/me')
      commit('setCurrentUser', { user })
    },

    logout({ commit }) {
      commit('setToken', { token: null })
      commit('setCurrentUser', { user: null })
    },

    async update(_, payload) {
      await actionClient.post('me', payload)
    },

    async queryActivity({commit}, data) {
      const res = await actionClient.get(`account-activities?account=${data.account}`)
      commit('setActiveList', res)
      return res
    }

  }


}
